import React, { useEffect, useRef, useState } from "react";
import ParentModal from "../parentModal";
import { all_routes } from "../../../router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import CommonSelect from "../../../../core/common/commonSelect";
import {
  allClass,
  names,
  parent,
  status,
} from "../../../../core/common/selectoption/selectoption";
import { parentData } from "../../../../core/data/json/parentlistdata";
import { TableData } from "../../../../core/data/interface";
import Table from "../../../../core/common/dataTable/index";
import TooltipOption from "../../../../core/common/tooltipOption";
import UserService from "../../../network/services/UserService";
import { getUser } from "../../../network/auth/Auth";

const ParentList = () => {
  const [show, setShow] = useState(false);
  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const data = parentData;
  const navigation = useNavigate();



  interface Option {
    id: any;
    name: any;
    phone: any;
    email: any;
    avatar: any;
    students: any;
    relation: any;

  }


  interface Option2 {
    name: any;
    phone: any;
    email: any;
    id: any;
    rfid_code: any;
    active: any;
    first_name: any;
    last_name: any;
    course_detail_ids: any;
    blood_group: any;
    gender: any;
    nationality: any;

    avatar: any;
    students: any;
    relation: any;
  }
  const [parentStudents, setParentStudents] = useState<Option2>();
  const [parents, setParents] = useState<Option[]>([]);
  const [isLoading, setIsLoading] = useState(false)
  const [branch, setBranch] = useState<any>();
  const branches = getUser().company_ids[0].branches;

  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    setIsLoading(true);
    UserService.getParentsAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false);
        setParents(response.data)
      } else {
        setIsLoading(false)
        setParents([])
      }
    });
  };



  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    setIsLoading(true);
    UserService.getParents(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false);
        setParents(response.data)


      } else {
        setIsLoading(false);
        setParents([])
      }
    });
  };

  useEffect(() => {
    fetchDataInit(getUser()?.company_ids[0]?.id);
  }, []);




  const showStudents = (studens: any) => {
    setShow(true)
    setParentStudents(studens)
    console.log(studens)
  }

  const navigeStudentDetails = (student: any) => {
    navigation(routes.studentDetail, { state: { student: student } })
  }



  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string) => (
        <Link to="#" onClick={() => setShow(true)} className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) => a.id.length - b.id.length,
    },
    {
      title: "Parent Name",
      dataIndex: "name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link
            to="#"
            className="avatar avatar-md"
            onClick={() => setShow(true)}
          >
            <img
              src={`data:image/png;base64,${record.avatar}`}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#" onClick={() => setShow(true)}>
                {text}
              </Link>
            </p>
            <span className="fs-12">{record.relation.name}</span>
          </div>
        </div>
      ),
      sorter: (a: TableData, b: TableData) => a.name.length - b.name.length,
    },
    {
      title: "Child",
      dataIndex: "students",
      render: (record: any) => (
        <div className="d-flex align-items-center">
          <Link to={routes.studentDetail} className="avatar avatar-md">
            <img
              src={`data:image/png;base64,${record[0]?.avatar}`}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{record[0]?.first_name}  {record[0]?.last_name} </Link>
            </p>
            <span className="fs-12">{record[0]?.email} </span>
          </div>
        </div>
      ),
      sorter: (a: TableData, b: TableData) => a.Child.length - b.Child.length,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a: TableData, b: TableData) => a.phone.length - b.phone.length,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: TableData, b: TableData) => a.email.length - b.email.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string, record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => showStudents(record)}
                  >
                    <i className="ti ti-menu me-2" />
                    View Parent
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_parent"
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Parents</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">People</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Parents
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_parent"
                  className="btn btn-primary"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Parent
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Parent List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Parents List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Parent</label>
                              <CommonSelect
                                className="select"
                                options={parent}
                                defaultValue={parent[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Child</label>
                              <CommonSelect
                                className="select"
                                options={names}
                                defaultValue={names[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={allClass}
                                defaultValue={allClass[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to={routes.parentList}
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.parentGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li >
                      <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                        All
                      </a>
                    </li>
                    {branches?.map((item: any) => (
                      <li key={item.id}>
                        <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              {

                <Table dataSource={parents} columns={columns} Selection={true} />
              }

              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <ParentModal />
      <Modal show={show} onHide={handleClose} centered size="lg">
        <div className="modal-header">
          <h4 className="modal-title">View Details</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body mb-0">
          <div className="parent-wrap">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="d-flex align-items-center mb-3">
                  <span className="avatar avatar-xl me-2">
                    <img
                      src={`data:image/png;base64,${parentStudents?.avatar}`}
                      alt="img"
                    />
                  </span>
                  <div className="parent-name">
                    <h5 className="mb-1">{parentStudents?.name}</h5>
                    <p>Added on 25 Mar 2024</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <ul className="d-flex align-items-center">
                  <li className="mb-3 me-5">
                    <p className="mb-1">Email</p>
                    <h6 className="fw-normal">{parentStudents?.email}</h6>
                  </li>
                  <li className="mb-3">
                    <p className="mb-1">Phone</p>
                    <h6 className="fw-normal">{parentStudents?.phone}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <h5 className="mb-3">Children Details</h5>
          {parentStudents?.students && parentStudents?.students.map((item: any, index: any) => (
            <div className="border rounded p-4 pb-1 mb-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap pb-1 mb-3 border-bottom">
                <span className="link-primary mb-2">RFID</span>
                {item?.active ? (
                  <span className="badge badge-soft-success badge-md mb-2">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Active
                  </span>
                ) : (
                  <span className="badge badge-soft-danger badge-md mb-2">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Inactive
                  </span>
                )
                }


              </div>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="d-flex align-items-center mb-3">
                  <Link to={routes.studentDetail} className="avatar">
                    <img
                      src={`data:image/png;base64,${item?.avatar}`}
                      className="img-fluid rounded-circle"
                      alt="img"
                    />
                  </Link>
                  <div className="ms-2">
                    <p className="mb-0">
                      <Link to={routes.studentDetail}>{item?.first_name} {item?.last_name}</Link>
                    </p>
                    <span>III, A</span>
                  </div>
                </div>
                <ul className="d-flex align-items-center flex-wrap">

                  <li className="mb-3 me-4">
                    <p className="mb-1">Gender</p>
                    <h6 className="fw-normal">{item?.gender === "f" ? "Female" : "Male"}</h6>
                  </li>

                </ul>
                <div className="d-flex align-items-center">
                  <Link to="#" className="btn btn-light mb-3 me-3">
                    Add Fees
                  </Link>
                  <a
                    onClick={() => navigeStudentDetails(item)}
                    className="btn btn-primary mb-3"
                  >
                    View Details
                  </a>
                </div>
              </div>
            </div>
          ))}

        </div>
      </Modal>
    </>
  );
};

export default ParentList;
